import Vue from "vue";
import { ValidationProvider, ValidationObserver, extend, localize, configure } from "vee-validate";
import ja from "vee-validate/dist/locale/ja.json";
import {
  required,
  email,
  integer,
  confirmed,
  // eslint-disable-next-line @typescript-eslint/camelcase
  alpha_num,
  max,
  min,
  digits,
  numeric,
  // eslint-disable-next-line @typescript-eslint/camelcase
  min_value,
} from "vee-validate/dist/rules";

import dayjs from "dayjs";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
// eslint-disable-next-line import/no-unresolved
import "@/assets/styles/index.scss";

Vue.config.productionTip = false;
const config = {
  bails: false,
  mode: "aggressive", // this is the default behavior and it validates whenever an input event is emitted.
};
configure(config);
extend("required", required);
extend("integer", integer);
extend("email", email);
extend("confirmed", confirmed);
extend("alpha_num", alpha_num);
extend("max", max);
extend("min", min);
extend("digits", digits);
extend("numeric", numeric);
extend("min_value", min_value);

/**
 * custom rules
 */
// 半角英字と数字を組み合わせ
extend("alpha_and_num", {
  message: "半角英字と数字を組み合わせてください",
  validate: value => {
    return value.match(/[0-9]/) && value.match(/[A-za-z]/);
  },
});
// 半角英字か数字か記号を入力
extend("alpha_num_symbol", {
  message: "半角英数字、記号（#$%*+-./:;?@_{}）のみ使用できます",
  validate: value => {
    return value.match(/[(0-9)(A-za-z)(#$%*+-./:;?@_{})]+$/);
  },
});

// YYYYMMDD形式日付バリデーション
extend("YYYYMMDD", {
  message: "YYYYMMDD形式で入力ください",
  validate: value => {
    const dateRule = /^[0-9]{4}(0[1-9]|1[0-2])(0[1-9]|[12][0-9]|3[01])/;
    return value.match(dateRule);
  },
});

// 生年月日の範囲バリデーション
extend("birthday_range", {
  message: `${Number(new Date().getFullYear()) - 100}年1月1日から今日までの日付で入力してください`,
  validate: value => {
    const today = new Date();
    if (
      Number(value) > Number(dayjs(today).format("YYYYMMDD")) ||
      Number(value.slice(0, 4)) < Number(today.getFullYear()) - 100
    ) {
      return false;
    }
    return true;
  },
});

localize("ja", ja);
Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App),
}).$mount("#app");
